import React, { useEffect, useState, useRef } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { FilterOption, degreeLevelOptions, areaStudyOptions, programOptions } from '../data/filterOptions';
interface FilterBarProps {
  degreeLevel: number;
  areaStudy: number;
  program: number;
  onDegreeLevelChange: (value: number) => void;
  onAreaStudyChange: (value: number) => void;
  onProgramChange: (value: number) => void;
}
function FilterDropdown({
  label,
  options,
  value,
  onChange
}: {
  label: string;
  options: FilterOption[];
  value: number;
  onChange: (value: number) => void;
}) {
  const [isOpen, setIsOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  const selectedLabel = options.find(o => o.value === value)?.label || options[0]?.label || '';
  useEffect(() => {
    function handleClickOutside(e: MouseEvent) {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setIsOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);
  return <div className="relative flex-1 min-w-0" ref={ref} data-id="element-139">
      <label className="absolute -top-2 left-3 bg-white px-1.5 text-[10px] font-semibold text-[#3b82f6] z-10 uppercase tracking-wider" data-id="element-140">
        {label}
      </label>
      <button type="button" onClick={() => setIsOpen(!isOpen)} className={`w-full bg-white border-2 ${isOpen ? 'border-[#3b82f6]' : 'border-gray-200'} rounded-lg py-2.5 px-3 flex items-center justify-between gap-2 focus:outline-none transition-colors text-left`} aria-haspopup="listbox" aria-expanded={isOpen} data-id="element-141">
        <span className="text-sm font-medium text-gray-900 truncate" data-id="element-142">
          {selectedLabel}
        </span>
        <ChevronDownIcon className={`w-4 h-4 text-gray-400 flex-shrink-0 transition-transform ${isOpen ? 'rotate-180' : ''}`} data-id="element-143" />
      </button>

      {isOpen && <div className="absolute top-full left-0 w-full mt-1 bg-white border border-gray-200 rounded-lg shadow-xl max-h-64 overflow-y-auto z-50" data-id="element-144">
          <ul role="listbox" className="py-1" data-id="element-145">
            {options.map(option => <li key={option.value} role="option" aria-selected={value === option.value} onClick={() => {
          onChange(option.value);
          setIsOpen(false);
        }} className={`px-3 py-2.5 cursor-pointer text-sm transition-colors ${value === option.value ? 'bg-blue-50 text-gray-900 font-medium' : 'text-gray-700 hover:bg-gray-50'}`} data-id="element-146">
                {option.label}
              </li>)}
          </ul>
        </div>}
    </div>;
}
export function FilterBar({
  degreeLevel,
  areaStudy,
  program,
  onDegreeLevelChange,
  onAreaStudyChange,
  onProgramChange
}: FilterBarProps) {
  const currentPrograms = programOptions[areaStudy] || [{
    value: 100,
    label: 'All Programs'
  }];
  return <div className="flex flex-col sm:flex-row gap-3 w-full" data-id="element-147">
      <FilterDropdown label="Degree Level" options={degreeLevelOptions} value={degreeLevel} onChange={onDegreeLevelChange} data-id="element-148" />
      <FilterDropdown label="Area of Study" options={areaStudyOptions} value={areaStudy} onChange={onAreaStudyChange} data-id="element-149" />
      <FilterDropdown label="Program" options={currentPrograms} value={program} onChange={onProgramChange} data-id="element-150" />
    </div>;
}